
import { defineComponent, onMounted } from "vue";
import "./styles/style.scss";

export default defineComponent({
  setup() {},
  data() {
    return {
      api_key: process.env.VUE_APP_API_KEY,
      base_url: "https://api.openweathermap.org/data/2.5/",
      query: "",
      weather: {},
      counter: 0,
      devcount: 0,
      hintcount: 0,
    };
  },
  mounted() {
    if (localStorage.counter) {
      this.counter = localStorage.counter;
    }
  },
  watch: {
    counter(newcounter) {
      localStorage.counter = newcounter;
    },
  },
  methods: {
    fetchingapi() {
      fetch(
        `${this.base_url}weather?q=${this.query}&units=metric&APPID=${this.api_key}`
      )
        .then((result) => {
          if (result.status == 404) {
            alert(`${this.query} is not found, try a different city`);
          }
          return result.json();
        })
        .then((result) => {
          this.weather = result;
        });
      setTimeout(this.clearingquery, 1000);
      setTimeout(this.areyouenjoying, 20000);
      this.hintcount++;
    },

    getdate() {
      let date = new Date();
      return date.toDateString();
    },
    clearingquery() {
      this.query = "";
    },
    areyouenjoying() {
      if (this.counter == 0) {
        alert(
          `Are you enjoying our app, please take a minute and send your feedback to the developer`
        );
        this.devcount = 1;
        this.counter++;
      }
    },
    hide() {
      this.devcount = 0;
    },
    onbtnclick() {
      this.devcount = 0;
    },
  },
  computed: {},
});
